import React, { PureComponent } from 'react'
import { Button, Modal, Col, FormGroup, Table } from 'react-bootstrap'
import InputSelect from '../../commons/form/InputSelect'
import InputDatePicker from '../../commons/form/InputDatePicker'
import { reduxForm, Field } from 'redux-form'
import { isEmail, customValidations } from '../../../util/validationFunctions'
import { validateBusinessRfcFormat, validateBusinessRfc, validateBusinessRfcDate } from '../../../util/mxEntityValidationFunctions'
import { documentEntityType as documentEntityTypeConstants } from '../../../constants/dossier/common/documentEntityType'
import DocumentListItemRecurrentEntity from '../../dossiers/common/documentaryManagement/documentaryManagementChild/DocumentListItemRecurrentEntity'
import { permissions, clientInformation, entityTypesId } from '../../../constants/backendIds'
import InputText from '../../commons/form/InputText'
import { commercialSocietyTypeIdFieldCode, commonCodes, recurrentEntityTabCode, rfcFieldCode, activityBproFields } from '../../../constants/dossier/common/fieldCodePermissions'
import { comboType, numberCombo, activityTypes } from '../../../constants/dossier/common/client'
import { EntityType } from '../../../constants/dossier/common/entityTypes'
import settings from '../../../setting'
import {
  asyncValidateRecurrentEntity, getFieldsRecurrentValidated
} from '../../../util/validationFunctionEntityDniAsync'
import { validationEntityPromisesOrder } from '../../../constants/validatedFields/backValidationPromisesOrder'
import promisesStatus from '../../../constants/promisesStatus'
import NormalizedAddress from '../../dossiers/common/client/NormalizedAddress'
import InputTreeSelect from '../../commons/form/InputTreeSelect'
import InputCheckBox from '../../commons/form/InputCheckBox'
import { handleKeyDown } from '../../../util/utils'

class RecurrentEntityModal extends PureComponent {
  constructor () {
    super()
    this.state = {
      entityId: null,
      name: null,
      emailAddress: null,
      selectedUo: null,
      uoList: [],
      organizedUnitId: null,
      documents: [],
      entitySubTypeDisabled: true,
      order: {
        columnName: null,
        direction: 'asc'
      },
      rfc: null,
      commercialSocietyTypeId: null,
      startStreet: null,
      enndStreet: null,
      externalNumber: null,
      internalNumber: null,
      countryCode: null,
      state: null,
      city: null,
      colonyCode: null,
      townCode: null,
      cp: null,
      combo: 0,
      alert: true,
      recurrentEntityTypeCombo: null,
      activityBproId: null,
      birthdayDate: null,
      constitutionAct: null,
      constitutionDate: null,
      private: false,
      bussiness: false,
      dniCifValidationDisable: null,
      representativeDniCifValidationDisable: null,
      dniCif: null,
      representativeDni: null
    }
  }

  dateLessTodayValidation (value, allValues, props) {
    const result = customValidations('LessToday', value, props)
    return result === Object(result) ? undefined : result
  }

  validatePermissions (type) {
    return this.state[type] && this.state[type].permission && this.state[type].permission !== permissions.hidden
  }

  submitRecurrentEntity (values) {
    const body = {
      ...values.recurrentEntity,
      adminMaster: true
    }

    this.props.actions.submitRecurrentEntity(this.props.entityId, body)
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (this.props.sections && (prevProps.sections !== this.props.sections || prevProps.showModal !== this.props.showModal) && this.props.sections.find(s => s.code === commonCodes.admin)) {
      let admin = this.props.sections.find(s => s.code === commonCodes.admin)
      let recEntTabCode = admin.sectionTabsConfiguration ? admin.sectionTabsConfiguration.find(x => x.code === recurrentEntityTabCode.recEntTabCode && x.permission > permissions.hidden) : null
      if (recEntTabCode && recEntTabCode.sectionFieldsConfiguration) {
        this.setState({ rfc: recEntTabCode.sectionFieldsConfiguration.find(x => x.code === rfcFieldCode.rfc) })
        this.setState({ startStreet: recEntTabCode.sectionFieldsConfiguration.find(x => x.code === rfcFieldCode.startStreet) })
        this.setState({ enndStreet: recEntTabCode.sectionFieldsConfiguration.find(x => x.code === rfcFieldCode.enndStreet) })
        this.setState({ externalNumber: recEntTabCode.sectionFieldsConfiguration.find(x => x.code === rfcFieldCode.externalNumber) })
        this.setState({ internalNumber: recEntTabCode.sectionFieldsConfiguration.find(x => x.code === rfcFieldCode.internalNumber) })
        this.setState({ countryCode: recEntTabCode.sectionFieldsConfiguration.find(x => x.code === rfcFieldCode.countryCode) })
        this.setState({ state: recEntTabCode.sectionFieldsConfiguration.find(x => x.code === rfcFieldCode.state) })
        this.setState({ city: recEntTabCode.sectionFieldsConfiguration.find(x => x.code === rfcFieldCode.city) })
        this.setState({ colonyCode: recEntTabCode.sectionFieldsConfiguration.find(x => x.code === rfcFieldCode.colonyCode) })
        this.setState({ townCode: recEntTabCode.sectionFieldsConfiguration.find(x => x.code === rfcFieldCode.townCode) })
        this.setState({ cp: recEntTabCode.sectionFieldsConfiguration.find(x => x.code === rfcFieldCode.cp) })
        this.setState({ activityBproId: recEntTabCode.sectionFieldsConfiguration.find(x => x.code === activityBproFields.activityBproId) })
        this.setState({ birthdayDate: recEntTabCode.sectionFieldsConfiguration.find(x => x.code === activityBproFields.birthdayDate) })
        this.setState({ constitutionAct: recEntTabCode.sectionFieldsConfiguration.find(x => x.code === activityBproFields.constitutionAct) })
        this.setState({ constitutionDate: recEntTabCode.sectionFieldsConfiguration.find(x => x.code === activityBproFields.constitutionDate) })
      }

      if (recEntTabCode && recEntTabCode.sectionFieldsConfiguration && recEntTabCode.sectionFieldsConfiguration.find(x => x.code === commercialSocietyTypeIdFieldCode.commercialSocietyTypeId)) {
        this.setState({ commercialSocietyTypeId: recEntTabCode.sectionFieldsConfiguration.find(x => x.code === commercialSocietyTypeIdFieldCode.commercialSocietyTypeId) })
      }
    }
    if (!this.props.showModal && this.props.showModal !== prevProps.showModal) {
      this.props.initialize({})
      this.setState({ entitySubTypeDisabled: true })
    }
    if (this.props.showModal && this.props.showModal !== prevProps.showModal) {
      if (this.props.entityId) {
        this.searchDocuments(this.props.entityId)
      }
      if (this.props.entityTypeId) {
        this.props.actions.fetchEntitySubTypeCombo(this.props.entityTypeId)
        this.setState({ entitySubTypeDisabled: false })
      }
      if (this.props.organizedUnitId) {
        this.setState({ selectedUo: this.props.organizedUnitId })
      }
      if (this.props.postalCodeCode) {
        this.setState({ combo: 5 })
      } else {
        this.setState({ combo: 0 })
      }
      this.setState({ private: false, bussiness: false })

      if (this.props.activityBproId) {
        let type = this.props.combos.activityBproCombo.find(x => x.id === this.props.activityBproId)?.type?.trim()?.toUpperCase()
        if (type === activityTypes.particular.trim().toUpperCase()) {
          this.setState({ private: true, bussiness: false })
        } else {
          this.setState({ private: false, bussiness: true })
        }
      }
    }

    return this.props
  }

  componentDidMount () {
    this.props.actions.fetchCommercialSocietyTypeCombo()
    this.props.actions.fetchEntityCountryTypeCombo()
    this.props.actions.fetchActivityBpro()
    this.setState({
      recurrentEntityTypeCombo: [
        { id: EntityType.RECURRING, value: this.props.t('ADMIN.RECURRENT_ENTITY_TYPE') },
        { id: EntityType.RECURRING_SERVICE, value: this.props.t('ADMIN.RECURRENT_SERVICE_ENTITY_TYPE') }]
    })
  }

  componentDidUpdate () {
    if (this.state.alert && this.props.combos[`entity${comboType[this.state.combo]}`]?.length === 0 && this.props.combos[`entity${comboType[this.state.combo - 1]}`]?.length > 0) {
      const alert = 'notData'
      this.props.actions.openModal(alert)
      this.setState({
        combo: this.state.combo - 1,
        alert: false
      })
      if (this.state.combo !== numberCombo.postalCodeCode) {
        this.props.actions[`fetchEntity${comboType[this.state.combo]}`]()
      }
    }
  }

  orderTable () {
    const columnName = this.state.order.columnName

    const documents = this.state.documents.sort(function (a, b) {
      if (columnName === 'validationDate') {
        const fechaInicial = a.validationDate ? a.validationDate.split(' ') : ['-']
        const separarA = fechaInicial.map((dia) => dia[0] === '-' ? ('01,01,2000,00,00') : (fechaInicial[0].split('/').join(',') + ',' + fechaInicial[1].split(':').join(',')))
        const fechaA = separarA.map((datos) => datos.split(','))
        const fechaFinal = b.validationDate ? b.validationDate.split(' ') : ['-']
        const separarB = fechaFinal.map((dia) => dia[0] === '-' ? ('01,01,2000,00,00') : (fechaFinal[0].split('/').join(',') + ',' + fechaFinal[1].split(':').join(',')))
        const fechaB = separarB.map((datos) => datos.split(','))
        const fecha1 = new Date(fechaA[0][2], fechaA[0][1], fechaA[0][0], fechaA[0][3], fechaA[0][4])
        const fecha2 = new Date(fechaB[0][2], fechaB[0][1], fechaB[0][0], fechaB[0][3], fechaB[0][4])
        return fecha2 - fecha1
      } else if (columnName === 'incorporationDate') {
        const fechaInicial = a.incorporationDate ? a.incorporationDate.split(' ') : ['-']
        const separarA = fechaInicial.map((dia) => dia[0] === '-' ? ('01,01,2000,00,00') : (fechaInicial[0].split('/').join(',') + ',' + fechaInicial[1].split(':').join(',')))
        const fechaA = separarA.map((datos) => datos.split(','))
        const fechaFinal = b.incorporationDate ? b.incorporationDate.split(' ') : ['-']
        const separarB = fechaFinal.map((dia) => dia[0] === '-' ? ('01,01,2000,00,00') : (fechaFinal[0].split('/').join(',') + ',' + fechaFinal[1].split(':').join(',')))
        const fechaB = separarB.map((datos) => datos.split(','))
        const fecha1 = new Date(fechaA[0][2], fechaA[0][1], fechaA[0][0], fechaA[0][3], fechaA[0][4])
        const fecha2 = new Date(fechaB[0][2], fechaB[0][1], fechaB[0][0], fechaB[0][3], fechaB[0][4])
        return fecha2 - fecha1
      } else if (columnName === 'checklistStatus') {
        return a.checklistStatus - b.checklistStatus
      } else if (a[columnName] && a[columnName].localeCompare) {
        return a[columnName].localeCompare(b[columnName])
      } else {
        return (isNaN(a[columnName]) ? 0 : a[columnName]) - (isNaN(b[columnName]) ? 0 : b[columnName])
      }
    })
    if (this.state.order.direction === 'asc') {
      documents.reverse()
    }
    this.setState({
      documents
    })
  }

  searchDocuments (entityId) {
    this.props.actions.fetchDocumentList(entityId)
  }

  handleOpenDocumentCreationModal (documentEntityType, documentTypeUse) {
    if (this.props.entityId) {
      this.props.actions.openDocumentCreationModal(null, documentEntityType, this.state.selectedUo, this.props.entityId, null, () => this.searchDocuments(this.props.entityId), true, null, null, true)
    } else {
      const alert = documentEntityType === documentEntityTypeConstants.ENTITY ? 'entityAlert' : 'vehicleAlert'
      this.props.actions.openModal(alert)
    }
  }

  changeDirection (columnName) {
    this.setState({
      order: {
        columnName: columnName,
        direction: this.state.order.direction === 'asc' ? 'desc' : 'asc'
      }
    }, this.orderTable)
  }

  changeOrderIcon (name) {
    let clase = 'ico-sort'
    if (this.state.order.direction === 'asc' && this.state.order.columnName === name) {
      clase += '-selected-asc'
    } else if (this.state.order.direction === 'desc' && this.state.order.columnName === name) {
      clase += '-selected-desc'
    }
    return clase
  }

  handleEntityTypeChange (entityTypeId) {
    if (entityTypeId) {
      this.setState({ entitySubTypeDisabled: false })
      this.props.actions.fetchEntitySubTypeCombo(entityTypeId)
    } else {
      this.setState({ entitySubTypeDisabled: true })
    }
  }

  handleEntityTypesChange (code, disable) {
    if (code) {
      if (disable !== 5) {
        this.props.actions[`fetchEntity${comboType[disable + 1]}`](this.props.combos[`entity${comboType[disable]}`].find(x => x.code === code)?.id)
        this.AddCombo()
      }
    } else {
      this.setState({ combo: (disable !== 0) ? disable - 1 : disable, alert: true })
    }
  }

  AddCombo () {
    this.setState({
      combo: this.state.combo + 1
    })
  }

  getActivitiesByType (type) {
    return this.props.combos.activityBproCombo.filter(x => x.type.toUpperCase().trim() === type.toUpperCase().trim())
  }

  handleEntityTypeActivity (value, type) {
    if (type === activityTypes.particular && value) {
      this.setState({ private: true, bussiness: false })
    } else if (type === activityTypes.empresa && value) {
      this.setState({ private: false, bussiness: true })
    } else {
      this.setState({ private: false, bussiness: false })
    }
  }

  disableDniValidation (value) {
    this.setState({ dniCifValidationDisable: value })
    if (value) {
      const dni = this.state.dniCif || this.props.dniCif
      this.props.clearFields(false, false, 'recurrentEntity.dniCif')
      this.props.change('recurrentEntity.dniCif', dni)
    }
  }

  disableDniRepValidation (value) {
    this.setState({ representativeDniCifValidationDisable: value })
    if (value) {
      const representativeDni = this.state.representativeDni || this.props.representativeDni
      this.props.clearFields(false, false, 'recurrentEntity.representativeDni')
      this.props.change('recurrentEntity.representativeDni', representativeDni)
    }
  }

  longSchema () {
    const {
      t,
      combos: { UOAcceptClientsCombo, entitySubTypeCombo, CSTCombo },
      actions: {
        fetchEntityCountryTypeCombo,
        fetchEntityStateTypeCombo,
        fetchEntityCityTypeCombo,
        fetchEntityTownTypeCombo,
        fetchEntityColonyTypeCombo,
        fetchEntityCPTypeCombo,
        fetchClientDataAddress
      }
    } = this.props

    let activitiesPrivate = this.getActivitiesByType(activityTypes.particular)
    let activitiesbussiness = this.getActivitiesByType(activityTypes.empresa)
    return (
      <div className='longSchema'>
        <div key={1} className="search-form">
          <Field
            component={InputCheckBox}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.dniCifValidationDisable"
            placeholder={t('ADMIN.RECURRENT_ENTITIES.DISABLE_DNI_CIF_VALIDATION')}
            onChange={(value) => this.disableDniValidation(value)}
          />
          <Field
            component={InputCheckBox}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.representativeDniCifValidationDisable"
            placeholder={t('ADMIN.RECURRENT_ENTITIES.DISABLE_REPR_DNI_CIF_VALIDATION')}
            onChange={(value) => this.disableDniRepValidation(value)}
          />
        </div>
        <div key={2} className="search-form">
          <Field
            component={InputText}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.clientNumber"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.CLIENT_NUMBER')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.CLIENT_NUMBER')}
          />
          <Field
            component={InputText}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.name"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.NAME')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.NAME')}
          />
          <Field
            component={InputText}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.representativeName"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.REPRESENTATIVE_NAME')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.REPRESENTATIVE_NAME')}
          />
          <Field
            component={InputText}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.representativeDni"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.REPRESENTATIVE_DNI')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.REPRESENTATIVE_DNI')}
            onChange={(e, value) => this.setState({ representativeDni: value })}
          />
          <Field
            component={InputSelect}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.organizedUnitId"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.UO')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.UO')}
            multi={false}
            valueKey="id"
            labelKey="value"
            childrenKey="children"
            options={UOAcceptClientsCombo}
            onChange={(el, value) => this.setState({ selectedUo: value })}
          />
          <Field
            component={InputSelect}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.entityTypeId"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.ENTITY_TYPE')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.ENTITY_TYPE')}
            multi={false}
            valueKey="id"
            labelKey="value"
            childrenKey="children"
            isClearable={false}
            options={[{ id: 3, value: 'Entidad Recurrente' }]}
            onInputChange={(value) => this.handleEntityTypeChange(value)}
          />
          <Field
            component={InputSelect}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.entitySubTypeId"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.ENTITY_SUB_TYPE')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.ENTITY_SUB_TYPE')}
            multi={false}
            disabled={this.state.entitySubTypeDisabled}
            valueKey="id"
            labelKey="value"
            childrenKey="children"
            options={entitySubTypeCombo}
          />
          {this.validatePermissions(rfcFieldCode.rfc) && (
            <Field
              component={InputText}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              name="recurrentEntity.rfc"
              colSm={0}
              controlLabel={t('DOSSIER_COMPONENTS.ENTITY.RFC')}
              placeholder={t('DOSSIER_COMPONENTS.ENTITY.RFC')}
            />

          )}
          <Field
            component={InputText}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.dniCif"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.DNICIF')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.DNICIF')}
            onChange={(e, value) => this.setState({ dniCif: value })}
          />
          <Field
            component={InputText}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.phone"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.PHONE')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.PHONE')}
          />
          <Field
            component={InputText}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.email"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.EMAIL')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.EMAIL')}
          />

          <NormalizedAddress
            t={t}
            fieldsConfiguration={{
              countryCode: this.state.countryCode,
              stateCode: this.state.state,
              cityCode: this.state.city,
              townCode: this.state.townCode,
              colonyCode: this.state.colonyCode,
              cpCode: this.state.cp
            }}
            readOnlyFields={false}
            allInformationDisabled={false}
            entityComponent= {this.props}
            entityTypeName= "recurrentEntity"
            actions={{
              fetchEntityCountryTypeCombo,
              fetchEntityStateTypeCombo,
              fetchEntityCityTypeCombo,
              fetchEntityTownTypeCombo,
              fetchEntityColonyTypeCombo,
              fetchEntityCPTypeCombo,
              fetchClientDataAddress
            }}
          />
          <Field
            component={InputText}
            colWidth={100} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.address"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.ADDRESS')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.ADDRESS')}
          />
          { this.validatePermissions(rfcFieldCode.externalNumber) && (
            <Field
              component={InputText}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              name="recurrentEntity.externalNumber"
              controlLabel={t('ADMIN.RECURRENT_ENTITIES.EXTERNAL_NUMBER')}
              placeholder={t('ADMIN.RECURRENT_ENTITIES.EXTERNAL_NUMBER')}
              maxLength="20"
            />

          )}
          { this.validatePermissions(rfcFieldCode.startStreet) && (

            <Field
              component={InputText}
              colWidth={66} // 25, 33, 50, 75, 100 default=25
              name="recurrentEntity.startStreet"
              controlLabel={t('ADMIN.RECURRENT_ENTITIES.START_STREET')}
              placeholder={t('ADMIN.RECURRENT_ENTITIES.START_STREET')}
              maxLength="200"
            />
          )}
          { this.validatePermissions(rfcFieldCode.internalNumber) && (
            <Field
              component={InputText}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              name="recurrentEntity.internalNumber"
              controlLabel={t('ADMIN.RECURRENT_ENTITIES.INTERNAL_NUMBER')}
              placeholder={t('ADMIN.RECURRENT_ENTITIES.INTERNAL_NUMBER')}
              maxLength="20"
            />
          )}
          { this.validatePermissions(rfcFieldCode.enndStreet) && (
            <Field
              component={InputText}
              colWidth={66} // 25, 33, 50, 75, 100 default=25
              name="recurrentEntity.enndStreet"
              controlLabel={t('ADMIN.RECURRENT_ENTITIES.ENND_STREET')}
              placeholder={t('ADMIN.RECURRENT_ENTITIES.ENND_STREET')}
              maxLength="200"
            />
          )}
          {this.state.commercialSocietyTypeId && this.state.commercialSocietyTypeId?.permission && this.state.commercialSocietyTypeId?.permission !== permissions.hidden && (
            <Field
              component={InputSelect}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              name="recurrentEntity.commercialSocietyTypeId"
              controlLabel={t('ADMIN.RECURRENT_ENTITIES.COMMERCIAL_SOCIETY')}
              placeholder={t('ADMIN.RECURRENT_ENTITIES.COMMERCIAL_SOCIETY')}
              multi={false}
              valueKey="id"
              labelKey="value"
              childrenKey="children"
              options={CSTCombo}
            />
          )}
          {this.state.activityBproId && this.state.activityBproId?.permission && this.state.activityBproId?.permission !== permissions.hidden && (
            <>
              <Field
                component={InputSelect}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                id="activityBproIdPrivate"
                name="recurrentEntity.activityBproId"
                key="recurrentEntity.activityBproId"
                controlLabel={t('DOSSIER_COMPONENTS.ENTITY.ACTIVITY_BPRO_PRIVATE')}
                placeholder={t('DOSSIER_COMPONENTS.ENTITY.ACTIVITY_BPRO_PRIVATE')}
                options={activitiesPrivate}
                valueKey="id"
                labelKey="value"
                onInputChange={(value) => this.handleEntityTypeActivity(value, activityTypes.particular)}
                disabled={this.state.bussiness}
              />
              <Field
                component={InputSelect}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                id="activityBproIdBussiness"
                name="recurrentEntity.activityBproId"
                key="recurrentEntity.activityBproId"
                controlLabel={t('DOSSIER_COMPONENTS.ENTITY.ACTIVITY_BPRO_BUSSINES')}
                placeholder={t('DOSSIER_COMPONENTS.ENTITY.ACTIVITY_BPRO_BUSSINES')}
                options={activitiesbussiness}
                valueKey="id"
                labelKey="value"
                onInputChange={(value) => this.handleEntityTypeActivity(value, activityTypes.empresa)}
                disabled={this.state.private}
              />
            </>
          )}
          {this.state.private && this.state.birthdayDate && this.state.birthdayDate?.permission && this.state.birthdayDate?.permission !== permissions.hidden && (
            <Field
              component={InputDatePicker}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              id="birthdayDate"
              name="recurrentEntity.birthdayDate"
              key="recurrentEntity.birthdayDate"
              controlLabel={t('DOSSIER_COMPONENTS.ENTITY.BIRTHDAY_DATE')}
              placeholder={t('DOSSIER_COMPONENTS.ENTITY.BIRTHDAY_DATE')}
              validate={[this.dateLessTodayValidation]}
              disabled={!this.state.private}
            />
          )}
          {this.state.bussiness && this.state.constitutionAct && this.state.constitutionAct?.permission && this.state.constitutionAct?.permission !== permissions.hidden && (

            <Field
              component={InputText}
              colWidth={66} // 25, 33, 50, 75, 100 default=25
              id="constitutionAct"
              name="recurrentEntity.constitutionAct"
              key="recurrentEntity.constitutionAct"
              controlLabel={t('DOSSIER_COMPONENTS.ENTITY.CONSTITUTION_ACT')}
              placeholder={t('DOSSIER_COMPONENTS.ENTITY.CONSTITUTION_ACT')}
              maxLength={50}
              disabled={!this.state.bussiness}
            />
          )}
          {this.state.bussiness && this.state.constitutionDate && this.state.constitutionDate?.permission && this.state.constitutionDate?.permission !== permissions.hidden && (
            <Field
              component={InputDatePicker}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              id="constitutionDate"
              name="recurrentEntity.constitutionDate"
              key="recurrentEntity.constitutionDate"
              controlLabel={t('DOSSIER_COMPONENTS.ENTITY.CONSTITUTION_DATE')}
              placeholder={t('DOSSIER_COMPONENTS.ENTITY.CONSTITUTION_DATE')}
              validate={[this.dateLessTodayValidation]}
              disabled={!this.state.bussiness}
            />
          )}

        </div>
      </div>
    )
  }

  shortSchema () {
    const {
      t,
      combos: { UOAcceptClientsCombo, entitySubTypeCombo, CSTCombo, UOTreeCombo }
    } = this.props
    return (
      <div className='shortSchema'>
        <div key={1} className="search-form">
          <Field
            component={InputCheckBox}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.dniCifValidationDisable"
            placeholder={t('ADMIN.RECURRENT_ENTITIES.DISABLE_DNI_CIF_VALIDATION')}
            onChange={(value) => this.disableDniValidation(value)}
          />
          <Field
            component={InputCheckBox}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.representativeDniCifValidationDisable"
            placeholder={t('ADMIN.RECURRENT_ENTITIES.DISABLE_REPR_DNI_CIF_VALIDATION')}
            onChange={(value) => this.disableDniRepValidation(value)}
          />
        </div>
        <div key={2} className="search-form">
          <Field
            component={InputText}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.clientNumber"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.CLIENT_NUMBER')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.CLIENT_NUMBER')}
          />
          <Field
            component={InputText}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.name"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.NAME')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.NAME')}
          />
          <Field
            component={InputText}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.dniCif"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.DNICIF')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.DNICIF')}
            onChange={(e, value) => this.setState({ dniCif: value })}
          />
          <Field
            component={InputText}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.phone"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.PHONE')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.PHONE')}
          />
          <Field
            component={InputText}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.email"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.EMAIL')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.EMAIL')}
          />
          <Field
            component={InputText}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.address"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.ADDRESS')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.ADDRESS')}
          />
          <Field
            component={InputText}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.city"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.CITY')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.CITY')}
          />
          <Field
            component={InputText}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.cp"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.CP')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.CP')}
          />
          <Field
            component={InputText}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.state"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.STATE')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.STATE')}
          />
          <Field
            component={InputText}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.representativeName"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.REPRESENTATIVE_NAME')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.REPRESENTATIVE_NAME')}
          />
          <Field
            component={InputText}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.representativeDni"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.REPRESENTATIVE_DNI')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.REPRESENTATIVE_DNI')}
            onChange={(e, value) => this.setState({ representativeDni: value })}
          />
          <Field
            component={InputSelect}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.organizedUnitId"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.UO')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.UO')}
            multi={false}
            valueKey="id"
            labelKey="value"
            childrenKey="children"
            options={UOAcceptClientsCombo}
            onChange={(el, value) => this.setState({ selectedUo: value })}
          />
          <Field
            component={InputSelect}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.entityTypeId"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.ENTITY_TYPE')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.ENTITY_TYPE')}
            multi={false}
            valueKey="id"
            labelKey="value"
            childrenKey="children"
            isClearable={false}
            options={[{ id: 3, value: 'Entidad Recurrente' }]}
            onInputChange={(value) => this.handleEntityTypeChange(value)}
          />
          <Field
            component={InputSelect}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.entitySubTypeId"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.ENTITY_SUB_TYPE')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.ENTITY_SUB_TYPE')}
            multi={false}
            disabled={this.state.entitySubTypeDisabled}
            valueKey="id"
            labelKey="value"
            childrenKey="children"
            options={entitySubTypeCombo}
            // options={[{id: 1, value: 'Renting SEAT'}, {id: 2, value: 'Renting VW'}, {id: 3, value: 'Renting Audi'}, {id: 3, value: 'Renting Skoda'}]}
          />
          <Field
            component={InputTreeSelect}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            name="recurrentEntity.recurrentServiceEntityOrganizedUnit"
            controlLabel={t('ADMIN.RECURRENT_ENTITIES.UO_RELATED_CAMPA')}
            placeholder={t('ADMIN.RECURRENT_ENTITIES.UO_RELATED_CAMPA')}
            multi={true}
            valueKey="value"
            labelKey="label"
            childrenKey="children"
            options={UOTreeCombo}
          />
          {this.props.entityTypeId && this.props.entityTypeId === entityTypesId.recurrentService &&
            <Field
              component={InputTreeSelect}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              name="recurrentEntity.recurrentServiceEntityOrganizedUnit"
              controlLabel={t('ADMIN.RECURRENT_ENTITIES.UO_RELATED_CAMPA')}
              placeholder={t('ADMIN.RECURRENT_ENTITIES.UO_RELATED_CAMPA')}
              multi={true}
              valueKey="value"
              labelKey="label"
              childrenKey="children"
              options={UOTreeCombo}
            />
          }
          {this.state.rfc && this.state.rfc.permission && this.state.rfc.permission !== permissions.hidden && (
            <Field
              component={InputText}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              name="recurrentEntity.rfc"
              colSm={0}
              controlLabel={t('DOSSIER_COMPONENTS.ENTITY.RFC')}
              placeholder={t('DOSSIER_COMPONENTS.ENTITY.RFC')}
            />
          )}
          {this.state.commercialSocietyTypeId && this.state.commercialSocietyTypeId?.permission && this.state.commercialSocietyTypeId?.permission !== permissions.hidden && (
            <Field
              component={InputSelect}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              name="recurrentEntity.commercialSocietyTypeId"
              controlLabel={t('ADMIN.RECURRENT_ENTITIES.COMMERCIAL_SOCIETY')}
              placeholder={t('ADMIN.RECURRENT_ENTITIES.COMMERCIAL_SOCIETY')}
              multi={false}
              valueKey="id"
              labelKey="value"
              childrenKey="children"
              options={CSTCombo}
            />
          )}

        </div>
      </div>
    )
  }

  validateSchema () {
    return (
      this.validatePermissions(rfcFieldCode.enndStreet) ||
      this.validatePermissions(rfcFieldCode.startStreet) ||
      this.validatePermissions(rfcFieldCode.externalNumber) ||
      this.validatePermissions(rfcFieldCode.internalNumber) ||
      this.validatePermissions(rfcFieldCode.countryCode) ||
      this.validatePermissions(rfcFieldCode.state) ||
      this.validatePermissions(rfcFieldCode.city) ||
      this.validatePermissions(rfcFieldCode.townCode) ||
      this.validatePermissions(rfcFieldCode.colonyCode) ||
      this.validatePermissions(rfcFieldCode.cp)
    )
  }

  render () {
    const {
      t, handleSubmit,
      showModal, entityId, documents,
      actions: { openDocumentEditionModal, cancelDocument, addDependant, printCheckList, openModal }
    } = this.props
    const tKey = 'RECURRENT_ENTITY_MANAGEMENT.'
    return (
      <Modal id="RecurrentEntityAdminModal" className="_nf" show={showModal} onHide={this.props.actions.closeEditRecurrentEntityModal}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitRecurrentEntity.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={this.props.actions.closeEditRecurrentEntityModal}>
            <Modal.Title>{t('RECURRENT_ENTITY_MANAGEMENT.MODAL.TITLE')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              { !this.validateSchema() ? (
                this.shortSchema()
              ) : (
                this.longSchema()
              )}
            </FormGroup>
            <div className="selectors">
              {entityId &&
              <>
                <div className="flexInLine al-L">
                  <Button
                    id="open-document-creation-modal"
                    className="_Btn new"
                    disabled={entityId == null}
                    onClick={() => this.handleOpenDocumentCreationModal(documentEntityTypeConstants.ENTITY, 2)}>
                    <i className='iDocIcon-add-plus'></i> {t('RECURRENT_ENTITY_MANAGEMENT.MODAL.ADD_DOCUMENTS')}
                  </Button>
                </div>
                <div className='section-results-body'>
                  <div className={'searchResoultsContainer'}>
                    <div className="table-wrapper" key="table-wrapper">
                      <Table hover responsive className="simple-table gestion-documental-table" id="documentary-management-table">
                        <thead>
                          <tr>
                            <th onClick={() => [this.changeDirection('documentStatus')]}><span>{t(`${tKey + 'DOCUMENTARY_MANAGEMENT.TABLE.STATUS'}`)}<i className={(() => [this.changeOrderIcon('documentStatus')])()}/></span></th>
                            <th onClick={() => [this.changeDirection('documentName')]}><span>{t(`${tKey + 'DOCUMENTARY_MANAGEMENT.TABLE.TYPES'}`)}<i className={(() => [this.changeOrderIcon('documentName')])()}/></span></th>
                            <th onClick={() => [this.changeDirection('validationDate')]}><span>{t(`${tKey + 'DOCUMENTARY_MANAGEMENT.TABLE.VALIDATION_DATE'}`)}<i className={(() => [this.changeOrderIcon('validationDate')])()}/></span></th>
                            <th onClick={() => [this.changeDirection('incorporationDate')]}><span>{t(`${tKey + 'DOCUMENTARY_MANAGEMENT.TABLE.ASSIGNMENT_DATE'}`)}<i className={(() => [this.changeOrderIcon('incorporationDate')])()}/></span></th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            documents && documents.map((documentFile, idx) => <DocumentListItemRecurrentEntity
                              t={t}
                              key={idx}
                              documentFile={documentFile}
                              readOnly={false}
                              documentEntityType={documentFile.documentEntityType}
                              objectId={entityId}
                              actions={{
                                openDocumentEditionModalWithChecklistId: (documentId, documentTypeUse, checklistId) => openDocumentEditionModal(documentId, documentTypeUse, documentFile.documentEntityType, null, entityId, null, this.state.organizedUnitId, checklistId, () => this.props.actions.fetchDocumentList(entityId), true, null, null, null, null, null, true, true),
                                cancelDocument,
                                printCheckList,
                                addDependant,
                                openModal
                              }}
                            />)
                          }
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </>
              }
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="btn-wrapper">
              <Button
                id="recurrent-entity-modal-submit-button"
                className="_Btn new"
                type="submit"
                disabled={this.props.pristine}
              >
                {t('RECURRENT_ENTITY_MANAGEMENT.MODAL.SUBMIT_BUTTON')}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

const validate = (values, props) => {
  let rfcValidation = null
  if (props.sections && props.sections.find(s => s.code === commonCodes.admin)) {
    let admin = props.sections.find(s => s.code === commonCodes.admin)
    let recEntTabCode = admin.sectionTabsConfiguration ? admin.sectionTabsConfiguration.find(x => x.code === recurrentEntityTabCode.recEntTabCode && x.permission > permissions.hidden) : null
    if (recEntTabCode && recEntTabCode.sectionFieldsConfiguration && recEntTabCode.sectionFieldsConfiguration.find(x => x.code === rfcFieldCode.rfc)) {
      rfcValidation = recEntTabCode.sectionFieldsConfiguration.find(x => x.code === rfcFieldCode.rfc)
    }
  }
  const error = { recurrentEntity: {} }
  if (values.recurrentEntity) {
    if (values.recurrentEntity.rfc && !validateBusinessRfcFormat(values.recurrentEntity.rfc)) {
      error.recurrentEntity.rfc = props.t('DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_RFC_ERROR_FORMAT')
    } else if (values.recurrentEntity.rfc && (!validateBusinessRfc(values.recurrentEntity.rfc) || !validateBusinessRfcDate(values.recurrentEntity.rfc))) {
      error.recurrentEntity.rfc = props.t('DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_RFC_ERROR_INVALID')
    }
    if (!values.recurrentEntity.name) {
      error.recurrentEntity.name = props.t('ADMIN.RECURRENT_ENTITIES.VALIDATION.NAME_REQUIRED')
    }
    if (!values.recurrentEntity.dniCif) {
      error.recurrentEntity.dniCif = props.t('ADMIN.RECURRENT_ENTITIES.VALIDATION.DNICIF_REQUIRED')
    } else if (rfcValidation && rfcValidation.permission === permissions.editable && !values.recurrentEntity.dniCifValidationDisable) {
      if (!validateBusinessRfcFormat(values.recurrentEntity.dniCif)) {
        error.recurrentEntity.dniCif = props.t('DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_RFC_ERROR_FORMAT')
      } else if (!validateBusinessRfc(values.recurrentEntity.dniCif) || !validateBusinessRfcDate(values.recurrentEntity.dniCif)) {
        error.recurrentEntity.dniCif = props.t('DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_RFC_ERROR_INVALID')
      }
    }
    if (!isEmail(values.recurrentEntity.email)) {
      error.recurrentEntity.email = props.t('ADMIN.RECURRENT_ENTITIES.VALIDATION.VALID_EMAIL')
    }
    if (!values.recurrentEntity.organizedUnitId) {
      error.recurrentEntity.organizedUnitId = props.t('ADMIN.RECURRENT_ENTITIES.VALIDATION.UO_REQUIRED')
    }
    if (!values.recurrentEntity.entityTypeId) {
      error.recurrentEntity.entityTypeId = props.t('ADMIN.RECURRENT_ENTITIES.VALIDATION.ENTITY_TYPE_REQUIRED')
    }
    if (!values.recurrentEntity.entitySubTypeId) {
      error.recurrentEntity.entitySubTypeId = props.t('ADMIN.RECURRENT_ENTITIES.VALIDATION.ENTITY_SUBTYPE_REQUIRED')
    }
    if (values.recurrentEntity.dniCif) {
      if (validateBusinessRfc(values.recurrentEntity.dniCif)) {
        if (!values.recurrentEntity.commercialSocietyTypeId && (this == null ? true : (this.state?.commercialSocietyTypeId && this.state?.commercialSocietyTypeId?.permission && this.state?.commercialSocietyTypeId?.permission !== permissions.hidden))) {
          error.recurrentEntity.commercialSocietyTypeId = props.t('ADMIN.RECURRENT_ENTITIES.VALIDATION.COMMERCIAL_SOCIETY_REQUIRED')
        }
      }
    }
    if (!values.recurrentEntity.countryCode) {
      error.recurrentEntity.countryCode = props.t('ADMIN.RECURRENT_ENTITIES.VALIDATION.COUNTRY_REQUIRED')
    }
    if (!values.recurrentEntity.stateCode) {
      error.recurrentEntity.stateCode = props.t('ADMIN.RECURRENT_ENTITIES.VALIDATION.STATE_REQUIRED')
    }
    if (!values.recurrentEntity.cityCode) {
      error.recurrentEntity.cityCode = props.t('ADMIN.RECURRENT_ENTITIES.VALIDATION.CITY_REQUIRED')
    }
    if (!values.recurrentEntity.townCode) {
      error.recurrentEntity.townCode = props.t('ADMIN.RECURRENT_ENTITIES.VALIDATION.TOWN_REQUIRED')
    }
    if (!values.recurrentEntity.colonyCode) {
      error.recurrentEntity.colonyCode = props.t('ADMIN.RECURRENT_ENTITIES.VALIDATION.COLONY_REQUIRED')
    }
    if (!values.recurrentEntity.postalCodeCode) {
      error.recurrentEntity.postalCodeCode = props.t('ADMIN.RECURRENT_ENTITIES.VALIDATION.CP_REQUIRED')
    }
    if (settings.clientFieldValidation === clientInformation.BUSS) {
      if (!values.recurrentEntity.activityBproId) {
        error.recurrentEntity.activityBproId = props.t('DOSSIER_COMPONENTS.VALIDATIONS.MANDATORY_FIELD')
      } else {
        let type = props.combos.activityBproCombo.find(x => x.id === values.recurrentEntity.activityBproId)?.type?.trim()?.toUpperCase()
        if (type === activityTypes.particular.trim().toUpperCase()) {
          if (!values.recurrentEntity.birthdayDate) {
            error.recurrentEntity.birthdayDate = props.t('DOSSIER_COMPONENTS.VALIDATIONS.MANDATORY_FIELD')
          }
        } else {
          if (!values.recurrentEntity.constitutionAct) {
            error.recurrentEntity.constitutionAct = props.t('DOSSIER_COMPONENTS.VALIDATIONS.MANDATORY_FIELD')
          }
          if (!values.recurrentEntity.constitutionDate) {
            error.recurrentEntity.constitutionDate = props.t('DOSSIER_COMPONENTS.VALIDATIONS.MANDATORY_FIELD')
          }
        }
      }
    }
  }
  return Object.keys(error.recurrentEntity).length > 0 ? error : {}
}

const asyncValidate = (values, dispatch, props, field, returnError) => {
  let promises = []
  if (values) {
    promises = promises.concat(asyncValidateRecurrentEntity(values.recurrentEntity, dispatch, props, values.recurrentEntity.organizedUnitId))
  }

  return Promise.allSettled(promises).then(result => {
    let error = {}
    for (let index = 0; index < result.length; index++) {
      const element = result[index]
      if (element.status === promisesStatus.FULFILLED) {
        switch (index) {
          case validationEntityPromisesOrder.ENTITY_COMPONENT_DNI_CIF:
            error = { ...error, recurrentEntity: element.value }
            break
          default:
            break
        }
      }
    }
    if (Object.keys(error).length > 0 && !returnError) throw Object.assign(new Error(), error)
    if (returnError) return error
  })
}

export default reduxForm({
  form: 'editRecurrentEntity',
  validate,
  asyncValidate,
  asyncBlurFields: [...getFieldsRecurrentValidated('recurrentEntity')]
})(RecurrentEntityModal)
